export * from './proposal-status.pipe';
